import {
  CLEAR_INTERVAL_ID,
  REMOVE_JOB,
  SCHEDULE_JOB,
  SET_INTERVAL_ID,
} from "../constants/reduxConstants";

const initialState = {
  seconds: 0,
  intervalId: undefined,
};
export const scheduleJobReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case SCHEDULE_JOB:
      return {
        ...state,
        seconds: state.seconds + payload,
      };
    case REMOVE_JOB:
      return {
        ...state,
        seconds: 0,
      };
    case SET_INTERVAL_ID:
      return {
        ...state,
        intervalId: payload,
      };
    case CLEAR_INTERVAL_ID:
      return {
        ...state,
        intervalId: undefined,
      };

    default:
      return state;
  }
};
